import { render, staticRenderFns } from "./SDBenutzer.vue?vue&type=template&id=22b2de80&scoped=true&"
import script from "./SDBenutzer.vue?vue&type=script&lang=js&"
export * from "./SDBenutzer.vue?vue&type=script&lang=js&"
import style0 from "./SDBenutzer.vue?vue&type=style&index=0&id=22b2de80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b2de80",
  null
  
)

export default component.exports